import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import IssueCreateModalLoadQuery, {
	type IssueCreateModalLoadQuery as IssueCreateModalLoadQueryType,
	type IssueCreateModalLoadQuery$variables,
} from '@jira/issue-create__issue-create-modal/src/relay/modal-load/__generated__/IssueCreateModalLoadQuery.graphql.ts';

type Queries = {
	modalLoadQueryReference: IssueCreateModalLoadQueryType;
};

type GlobalIssueCreateModernisedModalEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

type GlobalIssueCreateModernisedModalEntryPointParams = IssueCreateModalLoadQuery$variables;

export const globalIssueCreateModernisedModalEntryPoint: EntryPoint<
	GlobalIssueCreateModernisedModalEntryPointComponent,
	GlobalIssueCreateModernisedModalEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalIssueCreateModernisedModalEntryPointComponent>(
		/* webpackChunkName: "jira-global-issue-create-modernised-modal-entrypoint" */ './IssueCreateModalEntryPoint.tsx',
	),
	getPreloadProps: (variables) => ({
		queries: {
			modalLoadQueryReference: {
				parameters: IssueCreateModalLoadQuery,
				variables,
				options: { fetchPolicy: 'store-or-network' as const },
			},
		},
	}),
});
